import React from 'react';
import App from './App';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import * as serviceWorker from './serviceWorker';
import { CssBaseline } from '@material-ui/core';
import { Provider } from 'react-redux';
import store from 'app/store/store';
import { initIntl } from 'app/config/intl';
import { createRoot } from 'react-dom/client';

const renderApp = () => {
    const container = document.getElementById('root');
    const root = createRoot(container);
    root.render(
        <>
            <CssBaseline />
            <Provider store={store}>
                <App />
            </Provider>
        </>,
    );
};

const startApp = () => {
    initIntl(() => renderApp());
};

startApp();
serviceWorker.unregister();
